module.exports = __webpack_public_path__ + "img/Service.4726cbbe.png";